;(function ($) {
    var $w = $(window);
    $.fn.inViewport = function (params) {
        if (this.length < 1) return;

        var partial = params.partial || true,
            direction = params.direction || 'both',
            vOffset = params.vOffset || 0,
            hOffset = params.hOffset || 0,
            vOffsetPercent = params.vOffsetPercent || 0,
            hOffsetPercent = params.hOffsetPercent || 0;

        var $t = this.length > 1 ? this.eq(0) : this,
            t = $t.get(0),
            vpWidth = $w.outerWidth() * (1 - hOffsetPercent / 100) - hOffset,
            vpHeight = $w.outerHeight() * (1 - vOffsetPercent / 100) - vOffset;

        if (typeof t.getBoundingClientRect === "function") {
            var rec = t.getBoundingClientRect(),
                tViz = rec.top >= 0 && rec.top < vpHeight,
                bViz = rec.bottom > 0 && rec.bottom <= vpHeight,
                lViz = rec.left >= 0 && rec.left < vpWidth,
                rViz = rec.right > 0 && rec.right <= vpWidth,

                vVisible = partial ? tViz || bViz : tViz && bViz,
                hVisible = partial ? lViz || rViz : lViz && rViz,
                vVisible = rec.top < 0 && rec.bottom > vpHeight ? true : vVisible,
                hVisible = rec.left < 0 && rec.right > vpWidth ? true : hVisible;

            if (direction === "both") return vVisible && hVisible;
            else if (direction === "vertical") return vVisible;
            else if (direction === "horizontal") return hVisible;
        }
    };
})(jQuery);